import { APPLICATION_KEY } from '../constants';

export const SELECTED_SECURITY_KEY = 'security:selected';
export const APPLICATION_SELECTED_SECURITY_KEY = `${APPLICATION_KEY}:${SELECTED_SECURITY_KEY}`;
